import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import buyShadow from '../../assets/images/kit_open/color_blur.png';
import shadow from '../../assets/images/kit_open/shadow.png';
import { ICaseTagStyled } from '../CaseItem/CaseItem.model';

const StyledContainer = styled.div`
	position: relative;
	padding: 0 40px;
`;

const StyledBackgroundImage = styled.img`
	object-fit: cover;
	width: 100%;
	height: 500px;
	opacity: 0.5;
	user-select: none;
	pointer-events: none;
`;

const StyledBackgroundCollectionImage = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 500px;
	opacity: 0.5;
	user-select: none;
	pointer-events: none;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.collection-spinner {
		width: 100%;
		height: 100%;
	}
`;

const StyledShadow = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -40%);
	width: 1820px;
	height: 1000px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
`;

const StyledBackgroundContainer = styled.div`
	position: relative;
	height: 500px;
	border-radius: 10px;
	overflow: hidden;
	mask-image: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
	mask-size: 100% 100%;
	mask-repeat: no-repeat;
	mask-position: center;
	-webkit-mask-image: linear-gradient(
		180deg,
		#ffffff 0%,
		rgba(255, 255, 255, 0) 100%
	);
	-webkit-mask-size: 100% 100%;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-position: center;
`;

const StyledBorderSvg = styled.svg`
	position: absolute;
	top: 20px;
	left: 20px;
	width: calc(100% - 40px);
	height: 200px;
`;

const StyledKitName = styled(Text)`
	position: absolute;
	top: 165px;
	left: 50%;
	transform: translateX(-50%);
	color: #ffffff;
	font-weight: 700;
	text-align: center;
	text-transform: uppercase;

	span {
		display: block;
	}
`;

const StyledKitContent = styled.div`
	position: absolute;
	top: 278px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledTopContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledContainsTag = styled.div`
	display: flex;
	align-items: center;
	padding: 0 5px;
	height: 20px;
	background: rgba(255, 255, 255, 0.1);
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: rgba(255, 255, 255, 0.5);
	}
`;

const StyledTagsContainer = styled.div`
	display: flex;
	gap: 10px;
`;

const StyledDiscountTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	height: 20px;
	padding: 0 5px;
	background-color: #ff3d3d;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}

	.divider {
		width: 1px;
		height: 20px;
		background-color: rgba(0, 0, 0, 0.1);
	}
`;

const StyledTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 3px 5px;
	background: #ffffff;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #000000;
	}
`;

const StyledTag = styled.div<ICaseTagStyled>`
	padding: 3px 5px;
	background: ${(props) => props.$bgColorNormal};
	border-radius: 6px;
	transition: background-color 0.3s ease;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: ${(props) => props.$textColorNormal};
		transition: color 0.3s ease;
	}
`;

const StyledDiscountContainer = styled.div`
	padding: 3px 5px;
	background-color: #ff3d3d;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}
`;

const StyledItemsContainer = styled.div`
	display: flex;
	gap: 20px;
`;

const StyledBottomContainer = styled.div`
	position: absolute;
	top: 598px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const StyledPriceContainer = styled.div`
	position: relative;
	display: flex;
	gap: 20px;
	justify-content: flex-start;
	align-items: center;
	margin-top: 20px;
`;

const StyledPrice = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;

	img {
		transition: filter 0.3s ease;
	}

	${Text} {
		font-weight: 700;
		font-size: 30px;
		color: #ffffff;
		padding-top: 1px;
		transition: color 0.3s ease;
	}
`;

const StyledOldPrice = styled.div`
	position: relative;
	display: flex;
	gap: 6px;
	padding: 0 5px;
	margin-top: 2px;

	img {
		opacity: 0.25;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 500;
		font-size: 20px;
		color: #ffffff;
		opacity: 0.25;
		transition: color 0.3s ease;
	}

	.line {
		position: absolute;
		top: 10px;
		left: 0;
		width: 100%;
		height: 1px;
		background-color: #ff3737;
	}
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 20px;
	}
`;

const StyledBuyShadow = styled.div`
	position: absolute;
	top: -268px;
	left: 50%;
	transform: translateX(-50%);
	width: 1200px;
	height: 1000px;
	background-image: url(${buyShadow});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	pointer-events: none;
	z-index: -1;
`;

const StyledDecDots = styled.div`
	position: absolute;
	top: 15px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;

	.small {
		width: 4px;
		height: 4px;
		border-radius: 4px;
		background-color: #ffffff;
	}

	.big {
		width: 10px;
		height: 10px;
		border-radius: 10px;
		background-color: #ffffff;
	}
`;

export {
	StyledBackgroundCollectionImage,
	StyledBackgroundContainer,
	StyledBackgroundImage,
	StyledBorderSvg,
	StyledBottomContainer,
	StyledButtonContent,
	StyledBuyShadow,
	StyledContainer,
	StyledContainsTag,
	StyledDecDots,
	StyledDiscountContainer,
	StyledDiscountTimerContainer,
	StyledItemsContainer,
	StyledKitContent,
	StyledKitName,
	StyledOldPrice,
	StyledPrice,
	StyledPriceContainer,
	StyledShadow,
	StyledTag,
	StyledTagsContainer,
	StyledTimerContainer,
	StyledTopContainer,
};
